import { prosodies, statuses, updateType } from 'keys';
import { correct, incorrect, insertion, minorError, omission, repetition, selfCorrection } from 'keys/types';
import { findIndex, isEmpty, keyBy, map, pick } from 'lodash'
import update_type from 'mock/updateType';

/**
 * AssessmentRM - מחלקה לניתוח וסיכום שגיאות קריאה של תלמיד.
 * המערכת מקבלת מערך של מילים, כאשר לכל מילה יכולות להיות מספר שגיאות מסומנות.
 * * תפקיד הפונקציה:
 * 1. מציאת נקודת העצירה (Stop Point) - עד איפה לבדוק.
 * 2. מציאת נקודת הזמן הקצוב (Time Point) - לשם חישוב קצב ושטף (למשל מילים לדקה).
 * 3. ספירת שגיאות וביצוע "קיזוזים" כדי למנוע כפילויות במקרים בהם יש מספר סימונים על אותה מילה.
 * 4. חישוב סך המילים שנקראו בפועל והמילים הנכונות.
 */
class AssessmentRM {
    constructor(assessmentData) {
        const { transcriptionStopPoint, endPoint, timePoint = {}, words, prosody, comments } = assessmentData

        let currentProsody = prosody?.id || prosody

        let isProsodyValid = prosodies.some(item => item.id === currentProsody)

        if (isProsodyValid)
            this.prosody = currentProsody
        else
            this.prosody = null

        if (comments)
            this.comments = map(comments, 'id')

        this.time_point = timePoint?.value


        /////////////
        // כל החישובים הועברו לשרת
        // תחת reading_assessment_calculations_bl
        /////////////


        // --- שלב 1: איתור אינדקסים קריטיים במערך המילים ---

        // let timePointIndex = -1
        // if (timePoint)
        //     timePointIndex = findIndex(words, { 'word_def': timePoint.word_def_id });

        // let endPointIndex = -1
        // let transcriptionStopPointIndex = -1

        // if (!isEmpty(endPoint))
        //     // חיפוש בכל המילים את המילה שמסומן עליה שהיא האחרונה שנקראה
        //     endPointIndex = findIndex(words, { 'word_def': endPoint.word_def_id });

        // // אם לא נבחרה שום מילת סיום, המילה האחרונה היא מילת הסיום - רלוונטי לחישובים
        // if (endPointIndex === -1)
        //     endPointIndex = words.length - 1

        // if (!isEmpty(transcriptionStopPoint))
        //     // חיפוש בכל המילים את המילה שסימנו עליה שהיא האחרונה שנבדקה ע"י הבודק
        //     transcriptionStopPointIndex = findIndex(words, { 'word_def': transcriptionStopPoint.word_def_id });

        // // קביעת נקודת העצירה הסופית: אם יש נקודת בדיקה, היא קובעת. אחרת, נקודת סיום הקריאה.
        // let stopPointIndex
        // if (transcriptionStopPointIndex > -1)
        //     stopPointIndex = transcriptionStopPointIndex
        // else
        //     stopPointIndex = endPointIndex


        // --- שלב 2: הגדרת מונים (Counters) ---

        // let count = 0
        // let errorsCount = 0
        // let correctCount = 0
        // let correctWordsInTimePoint = 0

        // // מונים למקרי קצה בהם יש צירוף של שגיאות על אותה מילה
        // let selfCorrectionAndMinorError = 0
        // let omissionAndMinorError = 0
        // let omissionAndError = 0
        // let insertionAndMinorError = 0

        // סל איסוף בסיסי לכל סוג שגיאה 
        // let customErrorsCount = {
        //     [repetition]: 0,
        //     [selfCorrection]: 0,
        //     [minorError]: 0,
        //     [omission]: 0,
        //     [insertion]: 0,
        //     ["omissionInTimePoint"]: 0 // אוסף את *כל* ההשמטות (נקיות ומורכבות) עד לנקודת הזמן כדי להחסירן יחד בסוף
        // }

        // --- שלב 3: מעבר על המילים וספירה ---

        // for (let index = 0; index < words?.length; index++) {
        //     // אנחנו סופרים ומחשבים את הטעויות רק עד המילה האחרונה הרלוונטית
        //     if (index <= stopPointIndex) {
        //         let word = words[index]
        //         const { errors, status } = word

        //         // מסננים החוצה שגיאות שהמשתמש מחק/ביטל
        //         let nErrors = errors.filter((error) => error.update_type != update_type.delete)

        //         // ספירה ראשונית גסה של כל השגיאות התקפות
        //         nErrors.forEach(error => {
        //             if (error.status === omission && index <= timePointIndex)
        //                 customErrorsCount.omissionInTimePoint++
        //             customErrorsCount[error.status]++
        //         });

        //         // מיפוי השגיאות של המילה הנוכחית לגישה נוחה
        //         let errorKeys = keyBy(nErrors, "status")

        //         // --- שלב 3.1: קיזוזים למניעת ספירה כפולה של שגיאות משולבות ---

        //         // מקרה א': תיקון עצמי + שגיאה קלה. 
        //         // מקזזים מהספירה הכללית וסופרים רק כאירוע משולב אחד.
        //         if (errorKeys[minorError] && errorKeys[selfCorrection]) {
        //             selfCorrectionAndMinorError += 1

        //             customErrorsCount[minorError]--
        //             customErrorsCount[selfCorrection]--
        //         }

        //         // מקרה ב': השמטה במילה שגויה.
        //         if (status == incorrect && errorKeys[omission]) {
        //             customErrorsCount[omission]-- // מקזזים מההשמטות הנקיות

        //             // אם יש גם שגיאה קלה, זה נספר כ'השמטה+שגיאה קלה'. אחרת 'השמטה+שגיאה רגילה'
        //             if (errorKeys[minorError]) {
        //                 omissionAndMinorError += 1
        //                 customErrorsCount[minorError]--
        //             } else {
        //                 omissionAndError += 1
        //             }
        //         }

        //         // מקרה ג': הוספה + שגיאה קלה.
        //         if (errorKeys[insertion]) {
        //             if (errorKeys[minorError]) {
        //                 customErrorsCount[minorError]--
        //                 customErrorsCount[insertion]--
        //                 insertionAndMinorError++
        //             }
        //         }

        //         // --- שלב 3.2: חישובי שגיאות כלליות ומילים נכונות ---

        //         //  כולל את המילים עם השגיאות + שגיאות קלות + תיקונים עצמיים + הוספות לא כולל השמטות
        //         // הערה: יש לוודא שלמילה (word) באמת יש שדה update_type אם לזה התכוונת כאן
        //         if (status === incorrect && word.update_type != update_type.delete)
        //             errorsCount++

        //         // מילים נכונות לדקה (WPM): מילים תקינות, או עם שגיאה קלה/תיקון עצמי.
        //         if (index <= timePointIndex) {
        //             if (word.status === correct || errorKeys[minorError] || errorKeys[selfCorrection])
        //                 correctWordsInTimePoint++
        //         }

        //         // ספירת מילים נכונות מוחלטות (עד נקודת העצירה הכללית)
        //         if (index <= stopPointIndex && word.status === correct)
        //             correctCount++
        //     }
        // }

        // // --- שלב 4: השמה למאפייני המחלקה (הדוח הסופי) ---

        // // תיקון: שימוש בסוגריים מרובעים כדי לגשת לערך הדינמי מתוך משתני ה-Keys
        // this.repetition_count = customErrorsCount[repetition]
        // this.self_correction_count = customErrorsCount[selfCorrection]
        // this.errors_count = errorsCount
        // this.omission_count = customErrorsCount[omission]
        // this.minor_error_count = customErrorsCount[minorError]
        // this.self_correction_and_minor_error_count = selfCorrectionAndMinorError
        // this.insertion_count = customErrorsCount[insertion]
        // this.insertion_and_minor_error_count = insertionAndMinorError
        // this.correct_words_count = correctCount
        // this.omission_and_error_count = omissionAndError
        // this.omission_and_minor_error_count = omissionAndMinorError
        // this.omission_error_and_minor_error_count = omissionAndError + omissionAndMinorError


        // // חישוב סך המילים: האינדקס + 1, פחות *כל סוגי ההשמטות* (כי מילה שהושמטה לא נאמרה בפועל)
        // // תיקון: בדיקת undefined ו-0 למניעת קריסת הלוגיקה אם מילת העצירה היא הראשונה בטקסט
        // if (stopPointIndex !== undefined && stopPointIndex >= 0)
        //     this.words_count = stopPointIndex + 1 - customErrorsCount[omission] - omissionAndMinorError - omissionAndError
        // else
        //     this.words_count = words?.length - customErrorsCount[omission] - omissionAndMinorError - omissionAndError

        // // חישוב מילים עד נקודת הזמן (WPM)
        // if (!isEmpty(timePoint)) {
        //     // כאן ה-omissionInTimePoint כולל כבר את כל סוגי ההשמטות ולכן מספיק להחסיר רק אותו
        //     this.words_in_time_point = timePointIndex + 1 - customErrorsCount.omissionInTimePoint
        //     this.correct_words_in_time_point = correctWordsInTimePoint
        // }
    }
}

export default AssessmentRM